import { render, staticRenderFns } from "./SupplierEventProductModal.vue?vue&type=template&id=252fb2e9&scoped=true&"
import script from "./SupplierEventProductModal.vue?vue&type=script&lang=ts&"
export * from "./SupplierEventProductModal.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierEventProductModal.vue?vue&type=style&index=0&id=252fb2e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252fb2e9",
  null
  
)

export default component.exports